
/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/manufactorManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '厂家管理',
      icon: 'component',
    },
    children: [
      {
        path: '/manufactorManage/manufactorManage',
        component: () => import('@/myviews/shoppMall/manufactorManage/manufactorManage.vue'),
        alwaysShow: false,
        name: 'ManufactorManage',
        meta: {
          title: '厂家管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/manufactorManage.js